import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M6.827 6.18a2.31 2.31 0 0 1-1.641 1.055q-.57.08-1.134.175c-1.053.175-1.802 1.1-1.802 2.169v8.426a2.25 2.25 0 0 0 2.25 2.25h15a2.25 2.25 0 0 0 2.25-2.25V9.579c0-1.068-.75-1.994-1.802-2.17a48 48 0 0 0-1.134-.174 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.19 2.19 0 0 0-1.736-1.04 49 49 0 0 0-5.232 0 2.19 2.19 0 0 0-1.736 1.04z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M16.5 12.755a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m2.25-2.25h.008v.007h-.008z"
    }, null, -1)
  ])))
}
export default { render: render }